
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import DetailProduct from './DetailProduct';
import CategoriesScreen from './categories';
import HappyScreen from './happy';
import FootbalScreen from './footbal';
import TacosScreen from './taco';
function Index({dishs, setShowListProduct, setShowHappy}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const [menus, setMenus] = useState([]);
    const [dataFood, setDataFood] = useState(false);
    const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [dataDish, setDataDish] = useState(false); 
    const [grill, setGrill] = useState(false);
    const [ribeye, setRibeye] = useState(false);
     const [showCategories, setshowCategories] = useState(false);
  
    const [showHappy2, setShowHappy2] = useState(false);
       const [showFootbal, setshowFootbal] = useState(false);
    const [showTacos, setshowTacos] = useState(false);
    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
            setMenus(data);
        });
    }, []);
    

    useEffect(() => {
        menus.map((item) => {
            if (item.id === 257) {
                setDataFood(item.menus);
            }
        });
    }, [menus]);

    useEffect(() => {
        if (dataFood) {
            dataFood.map((item) => {
                if (item.id === 2811) {
                    setGrill(item);
                }
                if (item.id === 2385) {
                    setRibeye(item);
                }
            });
        }
    }, [dataFood]);
    
    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent showBack={true} setShowHappy={setShowHappy} setShowListProduct={setShowListProduct} goHome={setShowHappy} goCategories={setshowCategories}>
                <div  style={{padding: '0 20px', height: 790,  overflow: 'scroll', backgroundColor: 'white', borderRadius: 20}}>
                    <div
                       >
                        <div
                            onClick={() => {
                               // setshowFootbal(true)
                            }}>
                            <img
                                src={require('./assets/ladies-night.png')}
                                style={{
                                width: '100%',
                                height: 258,
                                objectFit: 'contain',
                                marginTop: 40,
                                }}
                            />
                            </div>
                            <div
                            onClick={() => {
                                setshowTacos(true)
                            }}>
                            <img
                                src={require('./assets/taco.png')}
                                style={{
                                width: '100%',
                                height: 210,
                                marginTop: 20,
                                    objectFit: 'cover',
                                borderRadius: 20,
                                }}
                            />
                            </div>

                            <div
                            onClick={() => {
                                setShowHappy2(true)
                            }}>
                            <img
                                src={require('./assets/happy.jpg')}
                                style={{
                                width: '100%',
                                height: 190,
                                marginTop: 20,
                                objectFit: 'contain',
                                }}
                            />
                            </div>
                    </div>

                </div>

                {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}

                {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={setShowDetailProduct}
                    setShowDetailProduct={setShowDetailProduct}
                />}

                {showFootbal && <FootbalScreen setShowHappy={setshowFootbal} />}
                {showTacos && <TacosScreen setShowHappy={setshowTacos} />}
                {showHappy2 && <HappyScreen setShowHappy={setShowHappy2} />}
            </LayoutContent>
        </div>
    );
}
export default Index;